/**
 * BOOT §3 — the last-foreground stamp writer.
 *
 * Mounted app-level (native-only, renders null) so it spans the WHOLE session:
 * NativeRoot unmounts the instant boot routes, so the `visibilitychange →
 * hidden` stamp must NOT live there or a background from /today would never
 * update it (and the next launch would misread its tier). On every
 * backgrounding it records "the app was last in the foreground now" in
 * Capacitor Preferences, which `readBootTier()` consults at the next launch.
 */
import { useEffect } from 'react';
import { markBootActive } from '../../lib/boot/bootTier';
import { isNativeApp } from '../../lib/platform';

export function BootActivityMount(): null {
  const native = isNativeApp();
  useEffect(() => {
    if (!native) return;
    const onVis = () => {
      if (document.visibilityState === 'hidden') void markBootActive();
    };
    document.addEventListener('visibilitychange', onVis);
    return () => document.removeEventListener('visibilitychange', onVis);
  }, [native]);
  return null;
}
